import React, { Component } from 'react';
import { Big3Common } from '../../js/IncludeManager'

/* 개발담당:이재호
 * 화면기능:포인트 충전완료 화면
 * 세부설명:
*/

export class PointCheck extends Component {
    static displayName = PointCheck.name;

    constructor(props) {
        super(props);
        this.state = {
        };

        this.CsName = Big3Common.ContentState;
        this.Amount = props.ContentState.Amount || "";
        this.Clod_Point = props.ContentState.Clod_Point || "";
        this.Card_Info = props.ContentState.Card_Info || "";
        this.handleMove_Click = this.handleMove_Click.bind(this);
    }
    //초기화
    componentDidMount() {
    }
    handleMove_Click() {
        window.location.href = "/MyPage/MyInfoMgr/Index";
    }
    render() {
        const amount = this.Amount
        const clod_point = this.Clod_Point
        const sum_point = Number(amount) + Number(clod_point);
        const card_info = this.Card_Info;

        return (
            <div class="container_box p_b_margin c_padding">

                <div class="check_messeage_box flex_c">
                    <div class="check_icon"></div>
                    <div class="txt">포인트 충전이<br></br>완료되었습니다!</div>
                </div>

                <div class="point_chargebox point_check_box">
                    <div class="point_check_list">
                        <div class="point_check flex_sb">
                            <div class="title">충전수단</div>
                            <div class="points">{card_info}</div>
                        </div>
                        <div class="point_check flex_sb">
                            <div class="title">충전금액</div>
                            <div class="recharge_amount">{Big3Common.Util.Money(amount)}원</div>
                        </div>
                        <div class="point_check flex_sb">
                            <div class="title">충전 전 보유포인트</div>
                            <div class="points">{Big3Common.Util.Money(clod_point)}P</div>
                        </div>
                    </div>
                    <div class="point_check total_point flex_sb">
                        <div class="title">충전 후 보유포인트</div>
                        <div class="available_points">{Big3Common.Util.Money(sum_point)}P</div>
                    </div>
                </div>

                <div class="catagory_button_box">
                    <button type="button" class="btn_v btn_v1" onClick={this.handleMove_Click}>확인</button>
                </div>

            </div>
        );
    }
}
